// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: rT2-p_Yv4e5n
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import NewSelectState from "../../NewSelectState"; // plasmic-import: qJ5gCB8LACfk/component
import DebtorContact from "../../DebtorContact"; // plasmic-import: DGii8JbubKdz/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicDebtorDetails.module.css"; // plasmic-import: rT2-p_Yv4e5n/css

createPlasmicElementProxy;

export const PlasmicDebtorDetails__VariantProps = new Array();

export const PlasmicDebtorDetails__ArgProps = new Array();

const $$ = {};

function PlasmicDebtorDetails__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "debtorName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "address1.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "city.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "zip.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "creditorName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "debtSituation.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "productName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__naYvF)}>
              <Stack__
                as={"div"}
                data-plasmic-name={"invoiceDetails"}
                data-plasmic-override={overrides.invoiceDetails}
                hasGap={true}
                className={classNames(projectcss.all, sty.invoiceDetails)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__mkqGm)}>
                  <div
                    data-plasmic-name={"title4"}
                    data-plasmic-override={overrides.title4}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title4
                    )}
                  >
                    {"Debt Information"}
                  </div>
                  <div
                    data-plasmic-name={"title12"}
                    data-plasmic-override={overrides.title12}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title12
                    )}
                  >
                    {
                      "Add as much information as you can about the outstanding payment that you want to collect"
                    }
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__iiZX)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__p8Sh
                    )}
                  >
                    {"Debtor Name"}
                  </div>
                  <input
                    data-plasmic-name={"debtorName"}
                    data-plasmic-override={overrides.debtorName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.debtorName
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "debtorName",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"Full Name"}
                    ref={ref => {
                      $refs["debtorName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["debtorName", "value"]) ??
                      ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"debtorNameError"}
                  data-plasmic-override={overrides.debtorNameError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtorNameError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Debtor Name is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Debtor Name is a required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__satvf)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__pcay6
                    )}
                  >
                    {"Amount of unpaid debt"}
                  </div>
                  <div
                    data-plasmic-name={"debtAmount"}
                    data-plasmic-override={overrides.debtAmount}
                    className={classNames(projectcss.all, sty.debtAmount)}
                  />
                </div>
                <div
                  data-plasmic-name={"debtAmountError"}
                  data-plasmic-override={overrides.debtAmountError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtAmountError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Amount of debt is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Amount of debt is a required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__vQq2E)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__lGqKc
                    )}
                  >
                    {
                      "Delinquency Date (when your customer's payment was originally due)"
                    }
                  </div>
                  <div
                    data-plasmic-name={"debtAge"}
                    data-plasmic-override={overrides.debtAge}
                    className={classNames(projectcss.all, sty.debtAge)}
                  />
                </div>
                <div
                  data-plasmic-name={"debtAgeError"}
                  data-plasmic-override={overrides.debtAgeError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.debtAgeError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Age of debt is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Delinquency Date is a required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div
                  className={classNames(projectcss.all, sty.freeBox___45J0Y)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__lykYa
                    )}
                  >
                    {"Name of the product or service delivered to the debtor"}
                  </div>
                  <input
                    data-plasmic-name={"productName"}
                    data-plasmic-override={overrides.productName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.productName
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "productName",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={``}
                    ref={ref => {
                      $refs["productName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, [
                        "productName",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"productError"}
                  data-plasmic-override={overrides.productError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.productError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Age of debt is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Name of the product or service is required"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__cHuTl)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__pw4Qb
                    )}
                  >
                    {"Creditor Name (who the debt is owed to)"}
                  </div>
                  <input
                    data-plasmic-name={"creditorName"}
                    data-plasmic-override={overrides.creditorName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.creditorName
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "creditorName",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={``}
                    ref={ref => {
                      $refs["creditorName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, [
                        "creditorName",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
                <div
                  data-plasmic-name={"creditorNameError"}
                  data-plasmic-override={overrides.creditorNameError}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.creditorNameError
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Age of debt is a required field"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Creditor Name is a required field"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__q7Ruc)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__jabkM
                    )}
                  >
                    {"Debtor's Address or Location (if known)"}
                  </div>
                  <input
                    data-plasmic-name={"address1"}
                    data-plasmic-override={overrides.address1}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.address1
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "address1",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"Address Line"}
                    ref={ref => {
                      $refs["address1"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["address1", "value"]) ??
                      ""
                    }
                  />

                  <input
                    data-plasmic-name={"city"}
                    data-plasmic-override={overrides.city}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.city
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, ["city", "value"])(
                          e.target.value
                        );
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"City"}
                    ref={ref => {
                      $refs["city"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["city", "value"]) ?? ""
                    }
                  />

                  <NewSelectState
                    data-plasmic-name={"state"}
                    data-plasmic-override={overrides.state}
                    className={classNames("__wab_instance", sty.state)}
                  />

                  <input
                    data-plasmic-name={"zip"}
                    data-plasmic-override={overrides.zip}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.zip
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, ["zip", "value"])(
                          e.target.value
                        );
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"ZIP"}
                    ref={ref => {
                      $refs["zip"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={
                      generateStateValueProp($state, ["zip", "value"]) ?? ""
                    }
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__f9Scx)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__eFkHf
                    )}
                  >
                    {"Description of the Debt Situation"}
                  </div>
                  <textarea
                    data-plasmic-name={"debtSituation"}
                    data-plasmic-override={overrides.debtSituation}
                    className={classNames(
                      projectcss.all,
                      projectcss.textarea,
                      sty.debtSituation
                    )}
                    onChange={async (...eventArgs) => {
                      (e => {
                        generateStateOnChangeProp($state, [
                          "debtSituation",
                          "value"
                        ])(e.target.value);
                      }).apply(null, eventArgs);
                    }}
                    ref={ref => {
                      $refs["debtSituation"] = ref;
                    }}
                    value={
                      generateStateValueProp($state, [
                        "debtSituation",
                        "value"
                      ]) ?? ""
                    }
                  />
                </div>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"invoiceDetails2"}
                data-plasmic-override={overrides.invoiceDetails2}
                hasGap={true}
                className={classNames(projectcss.all, sty.invoiceDetails2)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__kn5Zm)}>
                  <div
                    data-plasmic-name={"title5"}
                    data-plasmic-override={overrides.title5}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title5
                    )}
                  >
                    {"Debtor Contact Information"}
                  </div>
                  <div
                    data-plasmic-name={"title13"}
                    data-plasmic-override={overrides.title13}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title13
                    )}
                  >
                    {
                      "Add all of the contact information for any individual or company who owes this debt"
                    }
                  </div>
                </div>
                <div
                  data-plasmic-name={"contactStack"}
                  data-plasmic-override={overrides.contactStack}
                  className={classNames(projectcss.all, sty.contactStack)}
                >
                  <DebtorContact
                    data-plasmic-name={"debtorContact"}
                    data-plasmic-override={overrides.debtorContact}
                    className={classNames("__wab_instance", sty.debtorContact)}
                  />
                </div>
                <div
                  data-plasmic-name={"addContact"}
                  data-plasmic-override={overrides.addContact}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.addContact
                  )}
                >
                  {"Add Contact"}
                </div>
              </Stack__>
              <Stack__
                as={"div"}
                data-plasmic-name={"invoiceDetails3"}
                data-plasmic-override={overrides.invoiceDetails3}
                hasGap={true}
                className={classNames(projectcss.all, sty.invoiceDetails3)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__piIc8)}>
                  <div
                    data-plasmic-name={"title6"}
                    data-plasmic-override={overrides.title6}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title6
                    )}
                  >
                    {"Supporting Documentation"}
                  </div>
                  <div
                    data-plasmic-name={"title14"}
                    data-plasmic-override={overrides.title14}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title14
                    )}
                  >
                    {
                      "Upload as many documents as you can to show proof of the debt"
                    }
                  </div>
                </div>
                <div
                  data-plasmic-name={"supportingDocuments"}
                  data-plasmic-override={overrides.supportingDocuments}
                  className={classNames(
                    projectcss.all,
                    sty.supportingDocuments
                  )}
                />
              </Stack__>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {"Please enter all of the required fields"}
              </div>
              <div
                data-plasmic-name={"submitButton"}
                data-plasmic-override={overrides.submitButton}
                className={classNames(projectcss.all, sty.submitButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__wCL1
                  )}
                >
                  {hasVariant(globalVariants, "screen", "medium")
                    ? "Submit"
                    : "Submit"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "vertStack",
    "invoiceDetails",
    "title4",
    "title12",
    "debtorName",
    "debtorNameError",
    "debtAmount",
    "debtAmountError",
    "debtAge",
    "debtAgeError",
    "productName",
    "productError",
    "creditorName",
    "creditorNameError",
    "address1",
    "city",
    "state",
    "zip",
    "debtSituation",
    "invoiceDetails2",
    "title5",
    "title13",
    "contactStack",
    "debtorContact",
    "addContact",
    "invoiceDetails3",
    "title6",
    "title14",
    "supportingDocuments",
    "errorText",
    "submitButton"
  ],

  sidebar: ["sidebar"],
  vertStack: [
    "vertStack",
    "invoiceDetails",
    "title4",
    "title12",
    "debtorName",
    "debtorNameError",
    "debtAmount",
    "debtAmountError",
    "debtAge",
    "debtAgeError",
    "productName",
    "productError",
    "creditorName",
    "creditorNameError",
    "address1",
    "city",
    "state",
    "zip",
    "debtSituation",
    "invoiceDetails2",
    "title5",
    "title13",
    "contactStack",
    "debtorContact",
    "addContact",
    "invoiceDetails3",
    "title6",
    "title14",
    "supportingDocuments",
    "errorText",
    "submitButton"
  ],

  invoiceDetails: [
    "invoiceDetails",
    "title4",
    "title12",
    "debtorName",
    "debtorNameError",
    "debtAmount",
    "debtAmountError",
    "debtAge",
    "debtAgeError",
    "productName",
    "productError",
    "creditorName",
    "creditorNameError",
    "address1",
    "city",
    "state",
    "zip",
    "debtSituation"
  ],

  title4: ["title4"],
  title12: ["title12"],
  debtorName: ["debtorName"],
  debtorNameError: ["debtorNameError"],
  debtAmount: ["debtAmount"],
  debtAmountError: ["debtAmountError"],
  debtAge: ["debtAge"],
  debtAgeError: ["debtAgeError"],
  productName: ["productName"],
  productError: ["productError"],
  creditorName: ["creditorName"],
  creditorNameError: ["creditorNameError"],
  address1: ["address1"],
  city: ["city"],
  state: ["state"],
  zip: ["zip"],
  debtSituation: ["debtSituation"],
  invoiceDetails2: [
    "invoiceDetails2",
    "title5",
    "title13",
    "contactStack",
    "debtorContact",
    "addContact"
  ],

  title5: ["title5"],
  title13: ["title13"],
  contactStack: ["contactStack", "debtorContact"],
  debtorContact: ["debtorContact"],
  addContact: ["addContact"],
  invoiceDetails3: [
    "invoiceDetails3",
    "title6",
    "title14",
    "supportingDocuments"
  ],

  title6: ["title6"],
  title14: ["title14"],
  supportingDocuments: ["supportingDocuments"],
  errorText: ["errorText"],
  submitButton: ["submitButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDebtorDetails__ArgProps,
          internalVariantPropNames: PlasmicDebtorDetails__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDebtorDetails__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDebtorDetails";
  } else {
    func.displayName = `PlasmicDebtorDetails.${nodeName}`;
  }
  return func;
}

export const PlasmicDebtorDetails = Object.assign(
  // Top-level PlasmicDebtorDetails renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    vertStack: makeNodeComponent("vertStack"),
    invoiceDetails: makeNodeComponent("invoiceDetails"),
    title4: makeNodeComponent("title4"),
    title12: makeNodeComponent("title12"),
    debtorName: makeNodeComponent("debtorName"),
    debtorNameError: makeNodeComponent("debtorNameError"),
    debtAmount: makeNodeComponent("debtAmount"),
    debtAmountError: makeNodeComponent("debtAmountError"),
    debtAge: makeNodeComponent("debtAge"),
    debtAgeError: makeNodeComponent("debtAgeError"),
    productName: makeNodeComponent("productName"),
    productError: makeNodeComponent("productError"),
    creditorName: makeNodeComponent("creditorName"),
    creditorNameError: makeNodeComponent("creditorNameError"),
    address1: makeNodeComponent("address1"),
    city: makeNodeComponent("city"),
    state: makeNodeComponent("state"),
    zip: makeNodeComponent("zip"),
    debtSituation: makeNodeComponent("debtSituation"),
    invoiceDetails2: makeNodeComponent("invoiceDetails2"),
    title5: makeNodeComponent("title5"),
    title13: makeNodeComponent("title13"),
    contactStack: makeNodeComponent("contactStack"),
    debtorContact: makeNodeComponent("debtorContact"),
    addContact: makeNodeComponent("addContact"),
    invoiceDetails3: makeNodeComponent("invoiceDetails3"),
    title6: makeNodeComponent("title6"),
    title14: makeNodeComponent("title14"),
    supportingDocuments: makeNodeComponent("supportingDocuments"),
    errorText: makeNodeComponent("errorText"),
    submitButton: makeNodeComponent("submitButton"),
    // Metadata about props expected for PlasmicDebtorDetails
    internalVariantProps: PlasmicDebtorDetails__VariantProps,
    internalArgProps: PlasmicDebtorDetails__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicDebtorDetails;
/* prettier-ignore-end */
